import React from 'react'
import { Icon } from 'react-icons-kit'
import {
  userAdd,
  documentIcon,
  check,
  hdd,
  comments,
  boxBlank,
  userRemove,
} from 'react-icons-kit/metrize'
import { Link, withRouter } from 'react-router-dom'
import { checkIfAnyGrantedByGivenAuth } from '../../modules/authService'
import { connect } from 'react-redux'
import LogoutContainer from '../../components/auth/LogoutContainer'
import { clearInfo } from '../../storage'
import KioskCapacityLabel from '../KioskCapacityLabel'

class AppBar extends React.Component {
  state = {
    isMobileMenuOpen: false,
  }

  handleLogout = () => {
    clearInfo()
  }

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }))
  }

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  render() {
    const { auth, header, subHeader, hasBtnGroup = false } = this.props
    const { isMobileMenuOpen } = this.state

    return (
      <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div className="max-w-full px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo and Title Section */}
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex-shrink-0">
                <img
                  src={require('../../img/coral-logo.png')}
                  alt="Coral Logo"
                  className="h-12 w-auto"
                />
              </Link>

              {header && (
                <div className="hidden md:flex items-center border-l border-gray-300 pl-4 space-x-3">
                  <div>
                    <h1 className="text-sm font-medium text-gray-900">
                      {header}
                    </h1>
                    {subHeader && (
                      <p className="text-xs text-gray-500 mt-0.5">
                        {subHeader}
                      </p>
                    )}
                  </div>
                  {hasBtnGroup && (
                    <div className="flex-shrink-0">
                      <KioskCapacityLabel />
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Right Section - Nav or User */}
            {hasBtnGroup ? (
              <NavBarBtnGroupFull
                auth={auth}
                handleLogout={this.handleLogout}
                isMobileMenuOpen={isMobileMenuOpen}
                toggleMobileMenu={this.toggleMobileMenu}
                closeMobileMenu={this.closeMobileMenu}
              />
            ) : (
              <NavBarBtnGroupLoginOnly
                auth={auth}
                handleLogout={this.handleLogout}
              />
            )}
          </div>
        </div>
      </header>
    )
  }
}

const renderUserAuthenInfoButton = (auth, handleLogout) => {
  if (
    auth.isPrepared &&
    !checkIfAnyGrantedByGivenAuth(auth, ['user', 'report'])
  )
    return (
      <Link to="/login">
        <button className="flex items-center space-x-2 px-4 py-2 rounded-full border border-gray-300 hover:shadow-md transition-shadow">
          <Icon icon={userAdd} size={20} />
          <span className="text-sm font-medium">Login</span>
        </button>
      </Link>
    )
  else if (
    auth.isPrepared &&
    checkIfAnyGrantedByGivenAuth(auth, ['user', 'report'])
  )
    return (
      <Link to="/account-settings">
        <button
          className="flex items-center space-x-2 px-4 py-2 rounded-full border border-gray-300 hover:shadow-md transition-shadow"
          title="Account Settings"
        >
          <div className="w-8 h-8 rounded-full bg-primary-600 flex items-center justify-center">
            <Icon icon={userRemove} size={16} className="text-white" />
          </div>
          <span className="text-sm font-medium text-gray-700">
            Hi, {auth.user.name || '-'}
          </span>
        </button>
      </Link>
    )
  return null
}

export const NavBarBtnGroupFull = withRouter(
  ({
    auth,
    location,
    handleLogout,
    isMobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu,
  }) => {
    const navItems = [
      { path: '/checkin', icon: check, label: 'Check-in' },
      { path: '/station-report', icon: documentIcon, label: 'Station' },
      { path: '/summary-report', icon: hdd, label: 'Summary' },
      { path: '/assignment', icon: comments, label: 'Assignment' },
      { path: '/mark-final', icon: boxBlank, label: 'Quick Check' },
    ]

    return (
      <div className="flex items-center space-x-2 flex-shrink-0">
        {/* Hamburger Menu Button - Visible on mobile */}
        <button
          onClick={toggleMobileMenu}
          className="lg:hidden flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <svg
              className="w-6 h-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-6 h-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>

        {/* Navigation Items - Hidden on small screens */}
        <nav className="hidden lg:flex items-center space-x-1">
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              (item.path !== '/checkin' &&
                location.pathname.startsWith(item.path))

            return (
              <Link key={item.path} to={item.path}>
                <button
                  className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon icon={item.icon} size={18} />
                  <span className="hidden xl:inline">{item.label}</span>
                </button>
              </Link>
            )
          })}
        </nav>

        {/* User Button */}
        <div className="ml-2 pl-2 border-l border-gray-300 hidden lg:block">
          {renderUserAuthenInfoButton(auth, handleLogout)}
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className="lg:hidden fixed top-20 right-4 left-4 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden">
            <nav className="py-2">
              {navItems.map((item) => {
                const isActive =
                  location.pathname === item.path ||
                  (item.path !== '/checkin' &&
                    location.pathname.startsWith(item.path))

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={closeMobileMenu}
                  >
                    <button
                      className={`w-full flex items-center space-x-3 px-4 py-3 text-base font-medium transition-all ${
                        isActive
                          ? 'bg-primary-50 text-primary-700'
                          : 'text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <Icon icon={item.icon} size={20} />
                      <span>{item.label}</span>
                    </button>
                  </Link>
                )
              })}
              <div className="border-t border-gray-200 mt-2 pt-2 px-4">
                {renderUserAuthenInfoButton(auth, handleLogout)}
              </div>
            </nav>
          </div>
        )}

        {/* Backdrop for mobile menu */}
        {isMobileMenuOpen && (
          <div
            className="lg:hidden fixed inset-0 bg-black bg-opacity-25 z-40"
            onClick={closeMobileMenu}
          />
        )}
      </div>
    )
  },
)

export const NavBarBtnGroupLoginOnly = ({ auth, handleLogout }) => {
  return (
    <div className="flex items-center">
      {renderUserAuthenInfoButton(auth, handleLogout)}
    </div>
  )
}

export default connect(({ auth }) => ({ auth }))(AppBar)
